import { CommonModule } from '@angular/common';
import { Component, OnInit} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatCheckboxModule,
  MatCheckboxChange,
} from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { ActivatedRoute } from '@angular/router';
import { DateFormatService } from '@/app/services/date-format.service';
import { NgToastService } from 'ng-angular-popup';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@/app/environments/environment';
import { HttpClient } from '@angular/common/http';

// Components for clarification
import { AnswerSelectedQuestionsComponent } from '@/app/components/projects/shared/tendering/ITT/answer-selected-questions/answer-selected-questions.component';
import { CreateAddendumComponent } from "@/app/components/projects/project-development/tendering/inivitation-to-tender/itt-sender-side/Clarification/create-addendum/create-addendum.component";

import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';

interface Question {
  questionId: number;
  question: string;
  date: string;
  avatar: string;
}

interface AnsweredGroup {
  id: number;
  answer: string;
  questions: Question[];
  date?: string;
  files?: any[];
  newFiles?: any;
}

@Component({
  selector: 'app-rfp-clarification-queries',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,

    // Components for clarification
    AnswerSelectedQuestionsComponent,
    CreateAddendumComponent,

    MatDialogModule,

  ],
  templateUrl: './rfp-clarification-queries.component.html',
  styleUrl: './rfp-clarification-queries.component.css'
})
export class RfpClarificationQueriesComponent implements OnInit {
  projectId: number;
  rfpId: number;

  currentClarificationDialog = '';
  isExpanded = false;
  queries: any = [];
  queriesResponses: any = [];
  formattedQueriesResponses: any = [];
  selectedQueriesIds: any = [];
  selectedQueries:any;
  showAnswerDialogue: boolean = false;

  clarificationDialog: string = '';

  docUrl: string | null = null;

  highlightedQueryKey: string | null | number = null;


  constructor(
    private tenderingService: TenderingService,
    private route: ActivatedRoute,
    private dateService: DateFormatService,
    private toast: NgToastService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
     private getFileIconService: GetFileIconUtilityService,
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.projectId = params.get('projectId')
        ? parseInt(params.get('projectId'))
        : null;
      this.rfpId = params.get('rfpId') ? parseInt(params.get('rfpId')) : null;
    });

    this.getRfpApplicantQueries();
  }
  getFileIcon(file: {
    file: any;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
  populatedRfpQueries(rawQuestions) {
    rawQuestions.forEach((rawQuestion) => {
      this.queries.push({
        id: rawQuestion?.id,
        queryResponseId: rawQuestion?.query_response_id,
        query: rawQuestion?.question,
        date: this.dateService.formatDate(rawQuestion?.created_at),
        isSelected: false,

        // TODO:
        avatar:
          'https://storage.googleapis.com/a1aa/image/zEPAjIvYaPYMOh7zu6qdyFAjf7Qz2R3B3nMXb2N9N8WucBAKA.jpg',
      });
    });
  }

  // Toggle queries selection for answer
  toggleQuerySelection(event: MatCheckboxChange, query) {
    if (event.checked) {
      query.isSelected = true;
      this.selectedQueriesIds.push(query?.questionId);
    } else {
      query.isSelected = false;
      this.selectedQueriesIds = this.selectedQueriesIds.filter(
        (id: any) => id !== query?.questionId
      );
    }
  }

  // This is to highlight the clicked query
  toggleSelection(answerKey): void {
    this.highlightedQueryKey = this.highlightedQueryKey === answerKey ? null : answerKey;
  }

  instantReply(query) {
    this.selectedQueries=query;
    query.isSelected = true;
    this.selectedQueriesIds = query?.questionId;
    this.openRFPClarificationAnswerDialog(query);
  
  
  }

  // Expanded fucntion
  toggleDetails() {
    this.isExpanded = !this.isExpanded;
  }

  // When Dialog is closed or terminated after trigering a functionality
  handleDialog() {
    this.showAnswerDialogue = false;
  }

  showAddendumModal() {
    const dialogRef = this.dialog.open(CreateAddendumComponent, {
      width: '80vw',
      // height: '70vh',
      panelClass: 'custom-dialog-container',
      maxWidth: '80vw',
      maxHeight: '70vh',
      autoFocus: false, // Prevent automatic focus stealing
      disableClose: true, // Prevent closing on outside click
      data: {
        projectId: this.projectId,
        rfpId: this.rfpId,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.success) {
        this.toast.success('Addendum created successfully', 'SUCCESS', 5000);
        // TODO: navigate to addendums tab
      } else {
        console.warn('No valid approval found in the response:', result);
      }
    });
  }

  openRFPClarificationAnswerDialog(query:any) {
    // Check if user have selected atleast 1 query
    if (this.selectedQueriesIds.length === 0 ) {
      this.toast.warning('No queries selected', 'WARNING', 4000);
      return;
    }

    const dialogRef = this.dialog.open(AnswerSelectedQuestionsComponent, {
      width: '80vw',
      // height: '70vh',
      panelClass: 'custom-dialog-container',
      maxWidth: '80vw',
      maxHeight: '70vh',
      autoFocus: false, // Prevent automatic focus stealing
      disableClose: true, // Prevent closing on outside click
      data: {
        selectedQueriesIds: this.selectedQueriesIds,
        selectedQueries: query, 
        projectId: this.projectId,
        rfpId: this.rfpId,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.success) {
        console.warn('Success found in the response:', result);
        this.queries = [];
        this.formattedQueriesResponses = [];
        this.selectedQueriesIds = [];
        this.getRfpApplicantQueries();
      } else {
        console.warn('No valid approval found in the response:', result);
      }
    });
  }

  /**
   * Loop on the queries and responses data to create a formatted response
   *  answered: {
   *    9: {
   *      id: 9,
   *      answer: "<p>this is response</p>",
   *      questions: [
   *        { questionId: 1, question: "Earum ullam officiis consequatur molestias cumque." },
   *        { questionId: 2, question: "Tenetur est at rerum natus dolorem quidem error." }
   *      ]
   *    },
   *  },
   *  pending: {
   *    questions: [
   *      { questionId: 3, question: "Ex sequi eaque qui molestiae qui ab ea aut." },
   *    ]
   *  }
   */
  createFormattedQueriesList() {
    // Step 1: Create a map of answers using queryResponseId
    const answerMap = this.queriesResponses.reduce(
      (accumulator, currentResponse) => {
        accumulator[currentResponse.id] = currentResponse.answer;
        return accumulator;
      },
      {}
    );

    const filesMap = this.queriesResponses.reduce(
      (accumulator, currentResponse) => {
        accumulator[currentResponse.id] = currentResponse.attached_files  ? JSON.parse(currentResponse.attached_files) 
        : [];
        return accumulator;
        
      },

      {}
    );
    console.log("attach file",filesMap);


    const newFilesMap = this.queriesResponses.reduce(
      (accumulator, currentResponse) => {
        accumulator[currentResponse.id] = currentResponse.clarification_new_files;
        return accumulator;
      },
      {}
    );

    // Step 2: Map the queries to include answers (if available)
    const mappedQuestions = this.queries.map((query) => ({
      questionId: query.id,
      answerId: query.queryResponseId,
      question: query.query,
      answer: query.queryResponseId ? answerMap[query.queryResponseId] : null,
      files: query.queryResponseId ? filesMap[query.queryResponseId] : null,
      newFiles: query.queryResponseId ? newFilesMap[query.queryResponseId] : null,
      date: query.date,
      avatar: query.avatar,
    }));

    // Step 3: Group the questions into answered and pending
    this.formattedQueriesResponses = mappedQuestions.reduce(
      (result, currentQuestion) => {
        const { answerId, answer, files, questionId, question, date, avatar, newFiles } =
          currentQuestion;

        if (answerId) {
          // Group questions with the same answerId under "answered"
          if (!result.answered[answerId]) {
            result.answered[answerId] = {
              id: answerId,
              answer: answer,
              files: files,
              newFiles: newFiles,
              questions: [],
            };
          }
          result.answered[answerId].questions.push({
            questionId,
            question,
            date,
            avatar,
          });
        } else {
          // Add unanswered questions to "pending"
          result.pending.questions.push({ questionId, question, date, avatar });
        }

        return result;
      },
      { answered: {}, pending: { questions: [] } }
    );
  }

  // Method to retrieve typed answered group
  getAnsweredGroup(answeredGroup: any): AnsweredGroup {
    return answeredGroup.value as AnsweredGroup;
  }

  downloadRfpResponseDocument(
    event: Event,
    downloadLink: HTMLAnchorElement,
    id: number,
    filePath: string
  ): void {
    event.preventDefault();

    const parts = filePath.split('/');
    const _filePath = parts[parts.length - 1];

    const apiUrl = environment.apiUrl;
    const fullPath = `${apiUrl}/projects/${this.projectId}/tendering/rfp/${this.rfpId}/clarifications/download/documents/${id}/${_filePath}`;

    const href = downloadLink.getAttribute('href'); // Get the href attribute
    console.log('href:', href);
    if (href !== '#') {
      console.log('The download is already in progress');
      return;
    }

    // Fetch the image from the backend
    this.http.post(fullPath, {}, { responseType: 'blob' })
  .pipe(take(1))
  .subscribe({
    next: (blob: Blob) => {
      if (!(blob instanceof Blob)) {
        console.error('Received invalid blob response');
        return;
      }

      const docUrl = URL.createObjectURL(blob); // ✅ Create a blob URL

      // ✅ Option 1: Trigger Download
      // downloadLink.setAttribute('href', docUrl);
      // downloadLink.setAttribute('download', 'document.pdf'); // Set filename
      // downloadLink.click();

      // ✅ Option 2: Open in a new tab
      window.open(docUrl, '_blank'); 

      // ✅ Cleanup to prevent memory leaks
      setTimeout(() => URL.revokeObjectURL(docUrl), 5000);
    },
    error: (error) => {
      console.error('Error downloading document:', error);
    }
  });

  }

  getSanitizedHtml(question: string) {
    if (!question) {
      return '';
    }
    const sanitizedHtml = question.replace(
      '<p>',
      '<p style="margin-bottom: 0;">'
    );
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }

  /**
   * HTTP REQUESTS START
   */
  getRfpApplicantQueries() {
    return this.tenderingService
      .getRfpApplicantQueries(this.projectId, this.rfpId)
      .subscribe({
        next: (response: any) => {
          if (response.meta.success) {
            this.populatedRfpQueries(response?.data);
            this.getRfpApplicantQueriesResponses();
          }
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });
  }

  // Get all queries responses on this RFP
  getRfpApplicantQueriesResponses() {
    return this.tenderingService
      .getRfpApplicantQueriesResponses(this.projectId, this.rfpId)
      .subscribe({
        next: (response: any) => {
          if (response.meta.success) {
            this.queriesResponses = response?.data;

            // Create formatted questions list
            this.createFormattedQueriesList();
          }
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });
  }
  /**
   * HTTP REQUESTS END
  */
}
